import {
  categorizeNodes,
  extractExcludedAddresses,
  extractSearchedNodes,
} from './utils/processTracerGraphDataUtils';

/**
 * Process JSON for next node on tracer action plan and create messages
 * @param {Array} jsonFiles - Array of JSON file objects
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing processed JSON files and messages
 */
export const processTracerNextNode = (
  tracerGraphDataJsonFile,
  input,
  uploadedImages
) => {
  // Processing tracer data to send to ai chat
  // Step 1: Extract searched nodes
  const searchedNodes = extractSearchedNodes(tracerGraphDataJsonFile);
  // Step 2: Categorize all nodes
  const categorizedNodes = categorizeNodes(tracerGraphDataJsonFile);
  // Step 3: Identify addresses to exclude from search
  const excludedAddresses = extractExcludedAddresses(categorizedNodes);

  const tracerData = {
    ['rawTracerGraphData']: tracerGraphDataJsonFile,
  };
  const processedTracerMetaData = {
    ['alreadySerachedNodes']: searchedNodes,
    ['categorizedNodes']: categorizedNodes,
    ['doNotSearch']: excludedAddresses,
  };

  // Create first system message with original JSON data
  const systemDataMessage = {
    role: 'user',
    content: `
      Instructions:
      
      Analyze this Blockscope tracer visualization with extreme forensic scrutiny. You are given both the raw data and processed metadata
  
      Detailed raw Tracer Graph Data:
      ${JSON.stringify(tracerData, null, 2)}
  
      Detailed raw Tracer Graph Data:
      ${JSON.stringify(processedTracerMetaData, null, 2)}
      `,
  };

  // Create user message
  const userMessage = {
    role: 'user',
    content: [
      {
        type: 'text',
        text: input, //inputmessage is fetched from actionplan default
      },
      ...(uploadedImages
        ? uploadedImages.map((m) => ({ type: 'image', image: m[0] }))
        : []),
    ],
  };

  return {
    messages: {
      dataMessages: [systemDataMessage],
      userMessage,
    },
  };
};

